import React from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import "./style.scss";
import { useNavigate } from "react-router";

export default NiceModal.create(() => {
  const modal = useModal();
  const { points } = modal?.args ?? {};
  const navigate = useNavigate()

  function onModalClose() {
    modal.hide();
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={onModalClose}
      onAfterClose={() => modal.remove()}
      innerClass={"redeem-calendar2024"}
    >
      <SectionHeader>
        Deine Belohnung heute:
      </SectionHeader>
      <h2 className={`award-name`}>
        {points} punkte
      </h2>
      <div className="buttons-wrapper">
        <Button action={onModalClose}>
          Punkte eintauschen
        </Button>
      </div>
    </Modal>
  );
});
